import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { ProjectName } from "../../constants/main";
import i18nStore from "../../i18n/store";
import { AboutUsPath, ContactUsPath, TermsOfServicePath } from "../../routes/paths";


const Footer = observer((props: any) => {
    const translations = i18nStore.getTranslations;

    return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: { sm: 'center', md: 'left' },
                    position: "absolute",
                    bottom: 0,
                    width: '100%',
                    height: props.FooterHeight,
                    background: "white",
                    zIndex: 99,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: "center",
                        p: 1,
                        width: '100%',
                        borderTop: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Copyright />
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', px: 2 }}>
                        {/*<Link color="text.primary" to={AboutUsPath}>*/}
                        {/*    {translations.aboutUs}*/}
                        {/*</Link>*/}
                        {/*<Typography variant="body2" sx={{ display: 'inline', mx: 0.5, opacity: 0.5 }}>*/}
                        {/*    &nbsp;•&nbsp;*/}
                        {/*</Typography>*/}
                        <Link color="text.primary" to={TermsOfServicePath}>
                            {translations.termsOfService}
                        </Link>
                        <Typography variant="body2" sx={{ display: 'inline', mx: 0.5, opacity: 0.5 }}>
                            &nbsp;•&nbsp;
                        </Typography>
                        <Link color="text.primary" to={ContactUsPath}>
                            {translations.contact}
                        </Link>
                    </Box>
                </Box>
            </Box>
    );
});

export default Footer;


function Copyright() {
    return (
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
            {'©'}
            &nbsp;
            {new Date().getFullYear()}
            &nbsp;
            {ProjectName}
        </Typography>
    );
}
